import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['start', 'cook']


   async startTargetConnected(e){

       if(e.dataset.cookie === "true") {
           let cookieDiv = document.querySelector('#cookies')
           let ctr = 0
           while (cookieDiv === null) {
               if (ctr > 10)
                   break
               await new Promise(resolve => setTimeout(resolve, 50))
               cookieDiv = document.querySelector('#cookies')
               if (cookieDiv === null) {
                   ctr++
                   continue
               }
               break
           }

           document.querySelector('#cookies').classList.remove('hidden')
           document.querySelector('#cookies').classList.add('flex')
       } else {
           document.querySelector('#cookies').classList.remove('flex')
           document.querySelector('#cookies').classList.add('hidden')
       }
   }

   startTargetDisconnected(e){
       document.querySelector('#cookies').classList.remove('flex')
       document.querySelector('#cookies').classList.add('hidden')
   }
    cookTargetConnected(element) {
        if (document.querySelector('#panel') === null)
            return

        if (document.querySelector('#panel').classList.contains('startPanel')) {
            document.querySelector('#cookies').classList.remove('hidden')
            document.querySelector('#cookies').classList.add('flex')
        }
    }
}